import { render, staticRenderFns } from "./Apps.template.vue?vue&type=template&id=23cf2481&scoped=true&"
var script = {}
import style0 from "./Apps.template.vue?vue&type=style&index=0&id=23cf2481&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cf2481",
  null
  
)

export default component.exports